import _slicedToArray from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.test.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/group_icon.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-bbde0db6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode(" 默认权限设置 ");

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" 创建角色组 ");

var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  class: "mb10"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode("你所在的角色组：");

var _hoisted_6 = {
  class: "btn-content my-btn-content"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "blank10"
  }, null, -1);
});

var _hoisted_8 = {
  key: 0,
  class: "mb10"
};
var _hoisted_9 = {
  class: "btn-content"
};
var _hoisted_10 = ["onClick"];

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "blank10"
  }, null, -1);
});

var _hoisted_12 = {
  class: "flex0"
};
var _hoisted_13 = {
  class: "flex-m-between title"
};
var _hoisted_14 = {
  style: {
    "font-weight": "bold"
  }
};
var _hoisted_15 = {
  class: "userList"
};
var _hoisted_16 = {
  key: 0,
  src: _imports_0
};
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  class: "permissionGroup part-box filling"
};
var _hoisted_19 = {
  key: 0,
  class: "title ta-r"
};
var _hoisted_20 = {
  class: "permissionList"
};
var _hoisted_21 = {
  class: "auth-name"
};
var _hoisted_22 = {
  class: "role-remark part-box"
};
var _hoisted_23 = {
  key: 0,
  class: "ta-r"
};

var _hoisted_24 = /*#__PURE__*/_createTextVNode("保存");

var _hoisted_25 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_26 = /*#__PURE__*/_createTextVNode("编辑");

var _hoisted_27 = {
  class: "ta-r"
};

var _hoisted_28 = /*#__PURE__*/_createTextVNode("申请加入该角色组");

var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "blank10"
  }, null, -1);
});

var _hoisted_30 = {
  class: "mb20 flex-v-center"
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w80"
  }, "角色组ID：", -1);
});

var _hoisted_32 = {
  class: "flex-v-center mb20"
};

var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w80"
  }, "角色组：", -1);
});

var _hoisted_34 = {
  class: "flex0"
};

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w80"
  }, "备注：", -1);
});

var _hoisted_36 = {
  class: "mb20 flex-v-center"
};

var _hoisted_37 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w80"
  }, "角色组：", -1);
});

var _hoisted_38 = {
  class: "flex-v-center"
};

var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w80"
  }, "备注：", -1);
});

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "limit-set"
  }, " 默认权限设置 ", -1);
});

var _hoisted_41 = {
  class: "select-limit-content"
};
var _hoisted_42 = {
  class: "dialog-footer"
};

var _hoisted_43 = /*#__PURE__*/_createTextVNode("取 消");

var _hoisted_44 = /*#__PURE__*/_createTextVNode("确 定");

var _hoisted_45 = {
  class: "flex-m-around"
};

var _hoisted_46 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w100"
  }, "角色组名称", -1);
});

var _hoisted_47 = {
  class: "flex0"
};

var _hoisted_48 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    class: "w80"
  }, "角色组：", -1);
});

var _hoisted_49 = {
  class: "flex-v-center mt20"
};

var _hoisted_50 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    class: "w80"
  }, "有效期至：", -1);
});

var _hoisted_51 = {
  class: "flex0 mt20"
};

var _hoisted_52 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    class: "w80 mt10"
  }, "成员：", -1);
});

var _hoisted_53 = {
  class: "dialog-footer"
};

var _hoisted_54 = /*#__PURE__*/_createTextVNode("取 消");

var _hoisted_55 = /*#__PURE__*/_createTextVNode("确 定");

import { pick, cloneDeep } from 'lodash';
import authWrap from './components/authWrap.vue';
import authMember from './components/authMember.vue';
import selectLimit from './components/selectLimit.vue';
import modalDialog from './components/modalDialog.vue';
import { ref, reactive, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import DtMessage from '@/components/DtMessage';
import AuthService from '@/api/auth';
import { defaultAvatar } from '@/config/constant';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var initCurrentAuth = {
      id: '',
      name: '',
      member_list: [],
      module_list: []
    };
    var route = useRoute();
    var router = useRouter();
    var store = useStore();
    var _window$AppConfig$aut = window.AppConfig.authority,
        enableRoleSearch = _window$AppConfig$aut.enableRoleSearch,
        useOaAvatar = _window$AppConfig$aut.useOaAvatar;
    var addUserByGroupAuthorization = window.AppConfig.addUserByGroupAuthorization;
    var ADMIN_GROUP_ID = ref('BIZ_ADMIN_ROLE');
    var loadingStatus = ref(true);
    var authList = ref([]); // 添加成员dialog flag

    var dialogVisible = ref(false); // 添加成员用

    var membersEmail = ref(''); // 权限失效时间

    var impowerInvalidTime = ref('2099-12-31');
    var currentAuth = ref(cloneDeep(initCurrentAuth));
    var currentAuthCopy = ref({
      roleName: '',
      remark: ''
    });
    var editFlag = ref(false);
    var permissionForm = reactive({
      dialogVisible: false,
      id: '',
      create_user: ''
    }); // 默认权限设置 角色组

    var selectGroupData = ref([]); // 默认权限设置 单个用户

    var selectMemberData = ref([]); // 默认权限设置 弹框的 label

    var selectLimitOptions = ref([{
      label: '数据资源',
      value: 'DATASOURCE'
    }, {
      label: '分析视图',
      value: 'DATA_VIEW'
    }, {
      label: '业务看板',
      value: 'DASHBOARD'
    }]); // 默认权限设置 传入select组件的数据
    // 【种类label，编辑查看，title，select】

    var getPermInfoData = reactive({
      DATASOURCE: {},
      DATA_VIEW: {},
      DASHBOARD: {}
    });
    var optionsRole = reactive({
      title: '创建角色组',
      visible: false,
      show_btn: true,
      width: '510px'
    });
    var inputRole = ref(''); // true创建,false修改

    var isCreated = ref(true); // 修改的角色组id

    var changeId = ref(''); // 空间默认权限列表

    var bizCategoryList = ref([]);
    var remarkFlag = ref(false);
    var searchParams = reactive({
      appKey: route.params.project || 'beacon_olap'
    }); // 我的权限组

    var myRoleList = ref([]);
    var authOption = reactive({
      userSelected: [],
      selectedNames: [],
      groupSelected: []
    }); // computed

    var isAdmin = computed(function () {
      return store.state.user.userDetail.isAdmin;
    });
    var loginName = computed(function () {
      return store.state.user.userDetail.login_name;
    }); // 选中的权限 模块id

    var checkModuleIdList = computed(function () {
      var checkModuleIdListTmp = [];
      (currentAuth.value.module_list || []).forEach(function (auth) {
        auth.module_list.forEach(function (item) {
          if (item !== null && item !== void 0 && item.has_permission) {
            checkModuleIdListTmp.push(item === null || item === void 0 ? void 0 : item.module_id);
          }
        });
      });
      return checkModuleIdListTmp;
    });
    var editBtnText = computed(function () {
      return editFlag.value ? '保存角色组权限' : '编辑角色组权限';
    });
    var isBeacon = computed(function () {
      return searchParams.appKey === 'beacon_olap';
    });
    var bizId = computed(function () {
      return route.params.biz_url;
    });
    var commonQuery = computed(function () {
      // return `bizId=${bizId.value}&appKey=${searchParams.appKey}`;
      return {
        bizId: bizId.value,
        appKey: searchParams.appKey
      };
    });
    var applyRoleIndex = computed(function () {
      return myRoleList.value.findIndex(function (item) {
        return item.id === currentAuth.value.id;
      });
    });

    var updateAuthOption = function updateAuthOption(options) {
      authOption.userSelected = options.userSelected;
      authOption.groupSelected = options.groupSelected;
    }; // // 获取弹框的数据


    var getPermInfo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data$data;

        var data, _data$data2, response, categoryInfo;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return AuthService.getPermInfo(commonQuery.value);

              case 2:
                data = _context.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  response = (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.result;

                  if (response.length > 0) {
                    // 各模块 value label
                    categoryInfo = {
                      DATASOURCE: '数据资源',
                      CROWD: '人群包',
                      DATA_VIEW: '分析视图',
                      DASHBOARD: '业务看板'
                    };
                    response.forEach(function (item) {
                      var perInfoData = {};
                      perInfoData.category = item.category;
                      perInfoData.label = categoryInfo[item.category];
                      perInfoData.data_asset_action = item.dataAssetAction;
                      perInfoData.oneself_operation = item.oneSelfOperation;
                      var selectData = [].concat(_toConsumableArray(item.roleIdList), _toConsumableArray(item.userIdList)); // 处理 所有人还是我自己  存入数组，传入组件渲染

                      if (item.everyoneOperation) {
                        selectData = ['all'];
                      } else if (item.oneSelfOperation) {
                        selectData = ['self'];
                      }

                      getPermInfoData[item.category] = _objectSpread(_objectSpread({}, item), {}, {
                        label: categoryInfo[item.category],
                        selectData: selectData
                      });
                    });
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getPermInfo() {
        return _ref.apply(this, arguments);
      };
    }(); // 默认权限设置弹窗


    var showDialogVisible = function showDialogVisible() {
      getPermInfo();
      permissionForm.dialogVisible = true;
    };

    var getMyRole = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data3;

        var data, _data$data4;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return AuthService.getMyRole(commonQuery.value);

              case 2:
                data = _context2.sent;

                if (((_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.code) === 1) {
                  myRoleList.value = ((_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.result) || [];
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getMyRole() {
        return _ref2.apply(this, arguments);
      };
    }(); // 数组元素置顶


    var toFirst = function toFirst(fieldData, index) {
      if (index !== 0) {
        fieldData.unshift(fieldData.splice(index, 1)[0]);
      }

      return fieldData;
    }; // 对所有 人进行去重


    var unique2 = function unique2(arr, attr) {
      var res = new Map();
      return arr.filter(function (a) {
        return !res.has(a[attr]) && res.set(a[attr], 1);
      });
    }; // 处理传入权限设置的 组  的数据


    var getLimitGroupData = function getLimitGroupData(data) {
      var group = [];
      var member = [];
      var noAdminGroup = data === null || data === void 0 ? void 0 : data.filter(function (item) {
        return item.role_type !== ADMIN_GROUP_ID.value;
      });
      noAdminGroup.forEach(function (item) {
        var _item$member_list, _item$member_list2;

        group.push({
          label: "".concat(item === null || item === void 0 ? void 0 : item.name, "(").concat(item === null || item === void 0 ? void 0 : (_item$member_list = item.member_list) === null || _item$member_list === void 0 ? void 0 : _item$member_list.length, ")"),
          value: item.id
        });

        if (((_item$member_list2 = item.member_list) === null || _item$member_list2 === void 0 ? void 0 : _item$member_list2.length) >= 1) {
          item.member_list.forEach(function (item1) {
            member.push(item1);
          });
        }
      });
      selectGroupData.value = group;
      var memberData = Array.from(new Set(member));
      selectMemberData.value = unique2(memberData, 'login_name');
    }; // 获取权限列表


    var getAuthList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _data$data5;

        var roleId, data, _data$data6, result, adminIndex, _authList$value;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                roleId = route.params.roleId;
                _context3.next = 3;
                return AuthService.getRoleList(_objectSpread(_objectSpread({}, commonQuery.value), {}, {
                  memberFlag: true
                }));

              case 3:
                data = _context3.sent;
                loadingStatus.value = false;

                if (((_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : _data$data5.code) === 1) {
                  result = (_data$data6 = data.data) === null || _data$data6 === void 0 ? void 0 : _data$data6.result;

                  if (Array.isArray(result) && result.length > 0) {
                    adminIndex = result.findIndex(function (item) {
                      return item.role_type === ADMIN_GROUP_ID.value;
                    }); // 把空间管理元放在第一个位置

                    authList.value = toFirst(result, adminIndex);

                    if (roleId) {
                      currentAuth.value = authList.value.find(function (item) {
                        return item.id === roleId;
                      });
                    } else {
                      _authList$value = _slicedToArray(authList.value, 1);
                      currentAuth.value = _authList$value[0];
                    }

                    getLimitGroupData(authList.value);
                  } else {
                    currentAuth.value = cloneDeep(initCurrentAuth);
                    currentAuthCopy.value = {
                      name: '',
                      remark: ''
                    };
                    authList.value = [];
                  }
                } else {
                  // 清空当前角色组权限数据
                  currentAuth.value = cloneDeep(initCurrentAuth);
                  currentAuthCopy.value = {
                    name: '',
                    remark: ''
                  };
                  authList.value = [];
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getAuthList() {
        return _ref3.apply(this, arguments);
      };
    }(); // 修改权限


    var updatePermission = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _data$data7;

        var data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return AuthService.updateRoleModule(commonQuery.value, {
                  id: currentAuth.value.id,
                  moduleIdList: checkModuleIdList.value
                });

              case 2:
                data = _context4.sent;

                if (((_data$data7 = data.data) === null || _data$data7 === void 0 ? void 0 : _data$data7.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function updatePermission() {
        return _ref4.apply(this, arguments);
      };
    }(); // 编辑或保存角色组权限


    var editSubmit = function editSubmit() {
      if (editFlag.value) {
        updatePermission();
      }

      editFlag.value = !editFlag.value;
    };

    var updateDialogOption = function updateDialogOption(key, value) {
      optionsRole[key] = value;
    }; // 获取当前日期


    var getNowFormatDate = function getNowFormatDate() {
      var date = new Date();
      var seperator1 = '-';
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0".concat(month);
      }

      if (strDate >= 0 && strDate <= 9) {
        strDate = "0".concat(strDate);
      }

      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }; // // 获取单独权限用户列表


    var getCurrentAuth = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _data$data8;

        var data, _data$data9;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // 获取空间角色列表
                loadingStatus.value = true;
                _context5.next = 3;
                return AuthService.getRoleMemberList(_objectSpread(_objectSpread({}, commonQuery.value), {}, {
                  roleId: currentAuth.value.id
                }));

              case 3:
                data = _context5.sent;

                if (((_data$data8 = data.data) === null || _data$data8 === void 0 ? void 0 : _data$data8.code) === 1) {
                  loadingStatus.value = false;
                  currentAuth.value.member_list = ((_data$data9 = data.data) === null || _data$data9 === void 0 ? void 0 : _data$data9.result) || [];
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function getCurrentAuth() {
        return _ref5.apply(this, arguments);
      };
    }(); // 添加成员


    var addUser = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _data$data10;

        var reqObj, membersList, members, data, _data$data11, _data$data12;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                reqObj = {};
                reqObj.role_id_list = [currentAuth.value.id];
                membersList = []; // 外网取 emailList

                if (!addUserByGroupAuthorization && !enableRoleSearch) {
                  members = membersEmail.value.split(';');
                  members.forEach(function (user) {
                    if (user) {
                      membersList.push({
                        login_name: user,
                        member_type: 'USER'
                      });
                    }
                  });
                } else {
                  authOption.userSelected.forEach(function (user) {
                    membersList.push({
                      login_name: user,
                      member_type: 'USER'
                    });
                  });
                  authOption.groupSelected.forEach(function (item) {
                    membersList.push({
                      login_name: item.orgId,
                      member_type: 'ORG'
                    });
                  });
                }

                if (!(membersList.length === 0)) {
                  _context6.next = 7;
                  break;
                }

                ElMessage.error('成员不能为空');
                return _context6.abrupt("return");

              case 7:
                reqObj.member_list = membersList;
                reqObj.effective_time = getNowFormatDate();
                reqObj.expiry_time = impowerInvalidTime.value;

                if (!(new Date(reqObj.effective_time) >= new Date(reqObj.expiry_time))) {
                  _context6.next = 13;
                  break;
                }

                ElMessage.error('有效期须大于当前时间');
                return _context6.abrupt("return");

              case 13:
                loadingStatus.value = true;
                _context6.next = 16;
                return AuthService.updateMember(commonQuery.value, reqObj);

              case 16:
                data = _context6.sent;

                if (((_data$data10 = data.data) === null || _data$data10 === void 0 ? void 0 : _data$data10.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                  dialogVisible.value = false;
                  loadingStatus.value = false;
                  getCurrentAuth(); // 清空输入框

                  if (addUserByGroupAuthorization) {
                    membersEmail.value = '';
                  } else {
                    authOption.userSelected = [];
                    authOption.groupSelected = [];
                  }
                } else {
                  if ((_data$data11 = data.data) !== null && _data$data11 !== void 0 && _data$data11.msg) {
                    DtMessage({
                      type: 'warning',
                      message: (_data$data12 = data.data) === null || _data$data12 === void 0 ? void 0 : _data$data12.msg
                    });
                  }
                }

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function addUser() {
        return _ref6.apply(this, arguments);
      };
    }(); // 关闭添加成员窗口


    var closeAddUserDialog = function closeAddUserDialog() {
      // 清空输入框
      dialogVisible.value = false;

      if (addUserByGroupAuthorization.value) {
        membersEmail.value = '';
      } else {
        authOption.userSelected = [];
        authOption.groupSelected = [];
      }
    }; // 点击角色组时触发


    var changeCurrentAuth = function changeCurrentAuth(obj) {
      currentAuth.value = obj;
      editFlag.value = false;
      router.push({
        name: 'AuthRoleGroupFix',
        params: {
          roleId: obj.id
        }
      });
    }; // 删除用户


    var delUser = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(user) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                ElMessageBox.confirm("\u786E\u8BA4\u5220\u9664".concat(user.name, "\u5417\uFF1F"), '提示', {
                  type: 'warning',
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                  var _data$data13;

                  var reqObj, data;
                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          reqObj = {};
                          reqObj.id = currentAuth.value.id;
                          reqObj.member_list = [pick(user, ['login_name', 'member_type'])];
                          loadingStatus.value = true;
                          _context7.next = 6;
                          return AuthService.deleteMember(commonQuery.value, reqObj);

                        case 6:
                          data = _context7.sent;

                          if (((_data$data13 = data.data) === null || _data$data13 === void 0 ? void 0 : _data$data13.code) === 1) {
                            getCurrentAuth();
                          }

                          loadingStatus.value = false;

                        case 9:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                })));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function delUser(_x) {
        return _ref7.apply(this, arguments);
      };
    }();
    /**
     * 触发多选框值改变的函数
     * category '' 权限模块的value
     * member [] 选中的角色组和用户id
     * content '' 权限类型 EXE|DOWNLOAD|MODIFY|GRAND
     */


    var handleSelectChange = function handleSelectChange(category, member, content) {
      var everyoneOperation = false; // 是否选中 所有人

      var oneSelfOperation = false; // 是否选中 仅自己

      var roleIdList = [];
      var userIdList = []; // 多选框为空，则清空所有选项

      if (member.length === 0) {
        everyoneOperation = false;
        oneSelfOperation = false;
        roleIdList = [];
        userIdList = []; // 判断是否选中 所有人 或者 仅自己
      } else if (member.length === 1 && member[0] === 'all') {
        everyoneOperation = true;
      } else if (member.length === 1 && member[0] === 'self') {
        oneSelfOperation = true;
      } else {
        // 区分 member 中的 item 是角色组id  还是用户id; 角色组id是以 1004 开头的数字
        member.forEach(function (item) {
          if (/^1004/.test(item)) {
            roleIdList.push(item);
          } else {
            userIdList.push(item);
          }
        });
      } // 构造单个category的权限对象


      var categoryItem = {
        category: category,
        dataAssetAction: content,
        everyoneOperation: everyoneOperation,
        oneSelfOperation: oneSelfOperation,
        roleIdList: roleIdList,
        userIdList: userIdList
      }; // 构造所有category的权限对象

      if (bizCategoryList.value.length > 0) {
        var index = bizCategoryList.value.findIndex(function (item) {
          return item.category === categoryItem.category;
        });

        if (index === -1) {
          bizCategoryList.value.push(categoryItem);
        } else {
          bizCategoryList.value.splice(index, 1, categoryItem);
        }
      } else {
        bizCategoryList.value.push(categoryItem);
      }
    };

    var handleCancel = function handleCancel() {
      permissionForm.dialogVisible = false;
    }; // 默认权限设置 弹窗 发送 ajax


    var handleSubmit = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _data$data14;

        var body, data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                body = {
                  appKey: searchParams.appKey,
                  bizId: bizId.value,
                  bizCategoryList: bizCategoryList.value
                };
                _context9.next = 3;
                return AuthService.updateBizCategoryPermission(body);

              case 3:
                data = _context9.sent;

                // TODO  showMsg: true,
                if (((_data$data14 = data.data) === null || _data$data14 === void 0 ? void 0 : _data$data14.code) === 1) {
                  handleCancel();
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                }

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function handleSubmit() {
        return _ref9.apply(this, arguments);
      };
    }(); // 创建角色组


    var addMaster = function addMaster() {
      isCreated.value = true;
      optionsRole.visible = true;
      optionsRole.title = '创建角色组';
    }; // 确定添加或修改


    var submitRole = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _data$data15, name, data, _data$data16, changeData, _data;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (inputRole.value) {
                  _context10.next = 3;
                  break;
                }

                // this.$message.error('请输入名称');
                ElMessage.error('请输入名称');
                return _context10.abrupt("return");

              case 3:
                loadingStatus.value = true;

                if (!isCreated.value) {
                  _context10.next = 13;
                  break;
                }

                name = {
                  name: inputRole.value,
                  appKey: searchParams.appKey
                };
                _context10.next = 8;
                return AuthService.addRole(commonQuery.value, name);

              case 8:
                data = _context10.sent;
                loadingStatus.value = false;

                if (((_data$data15 = data.data) === null || _data$data15 === void 0 ? void 0 : _data$data15.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                  getAuthList();
                  optionsRole.visible = false;
                  inputRole.value = '';
                } else {
                  DtMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

                _context10.next = 19;
                break;

              case 13:
                changeData = {
                  id: changeId.value,
                  roleName: inputRole.value
                };
                _context10.next = 16;
                return AuthService.updateRoleName(commonQuery.value, changeData);

              case 16:
                _data = _context10.sent;
                loadingStatus.value = false;

                if (((_data$data16 = _data.data) === null || _data$data16 === void 0 ? void 0 : _data$data16.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                  getAuthList();
                  optionsRole.visible = false;
                  inputRole.value = '';
                } else {
                  DtMessage({
                    message: _data.data.msg,
                    type: 'error'
                  });
                }

              case 19:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function submitRole() {
        return _ref10.apply(this, arguments);
      };
    }(); // 删除按钮


    var delBtn = function delBtn(item, index) {
      // 组内有人员不能删除
      if (item.member_list.length) {
        ElMessageBox.confirm('该角色组仍有成员，暂不支持删除，若坚持删除请移除成员后再进行删除操作。', '提示', {
          confirmButtonText: '好的',
          cancelButtonText: '不删了',
          type: 'warning'
        });
        return;
      }

      var id = {
        id: item.id
      };
      ElMessageBox.confirm('删除角色组后，同步会收回该角色组的全部授权，是否确认删除该角色组？', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _data$data17;

        var data;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                loadingStatus.value = true;
                _context11.next = 3;
                return AuthService.deleteRole(commonQuery.value, id);

              case 3:
                data = _context11.sent;
                loadingStatus.value = false;

                if (((_data$data17 = data.data) === null || _data$data17 === void 0 ? void 0 : _data$data17.code) === 1) {
                  getAuthList();
                  optionsRole.visible = false;

                  if (item.id === currentAuth.value.id) {
                    changeCurrentAuth(authList.value[index - 1]);
                  }
                }

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      })));
    };

    var editRemark = function editRemark() {
      currentAuthCopy.value.roleName = currentAuth.value.name;
      currentAuthCopy.value.remark = currentAuth.value.remark || '';
      remarkFlag.value = true;
    };

    var saveRemark = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _data$data18;

        var data, _data$data19;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return AuthService.updateRoleInfo(commonQuery.value, _objectSpread({
                  id: currentAuth.value.id
                }, currentAuthCopy.value));

              case 2:
                data = _context12.sent;

                if (((_data$data18 = data.data) === null || _data$data18 === void 0 ? void 0 : _data$data18.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                  authList.value.some(function (item) {
                    if (item.id === currentAuth.value.id) {
                      item.name = currentAuthCopy.value.roleName;
                      item.remark = currentAuthCopy.value.remark;
                      return true;
                    }

                    return false;
                  });
                  remarkFlag.value = false;
                } else {
                  DtMessage({
                    type: 'error',
                    message: (_data$data19 = data.data) === null || _data$data19 === void 0 ? void 0 : _data$data19.msg
                  });
                }

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function saveRemark() {
        return _ref12.apply(this, arguments);
      };
    }();

    var applyRoleGroup = function applyRoleGroup() {
      ElMessageBox.confirm("\u4F60\u786E\u5B9A\u8981\u7533\u8BF7\u52A0\u5165\u89D2\u8272\u7EC4\u3010".concat(currentAuth.value.name, "\u3011\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var _data$data20;

        var data, _data$data21, _data$data22;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return AuthService.applyRole({
                  appKey: searchParams.appKey,
                  bizId: bizId.value,
                  categoryKey: 'BIZ',
                  handler: loginName.value,
                  roleId: currentAuth.value.id
                });

              case 2:
                data = _context13.sent;

                if (((_data$data20 = data.data) === null || _data$data20 === void 0 ? void 0 : _data$data20.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '申请成功，你可以在【我的申请列表】查看你详细的申请记录'
                  });
                } else {
                  if ((_data$data21 = data.data) !== null && _data$data21 !== void 0 && _data$data21.msg) {
                    DtMessage({
                      type: 'warning',
                      message: (_data$data22 = data.data) === null || _data$data22 === void 0 ? void 0 : _data$data22.msg
                    });
                  }
                }

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      })));
    };

    var getUserAvatar = function getUserAvatar(avatar, name) {
      if (avatar) {
        return avatar;
      }

      return useOaAvatar ? "//dcloud.oa.com/Public/Avatar/".concat(name, ".png") : defaultAvatar;
    };

    onMounted(function () {
      getMyRole();
      getAuthList();
    });
    watch([function () {
      return bizId.value;
    }, function () {
      return route.params.project;
    }], /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(newval, oldval) {
        var _ref15, _ref16;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _ref15 = newval || 'beacon_olap';
                _ref16 = _slicedToArray(_ref15, 2);
                searchParams.appKey = _ref16[1];
                getMyRole();
                getAuthList();

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x2, _x3) {
        return _ref14.apply(this, arguments);
      };
    }());
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      var _component_close = _resolveComponent("close");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_dialog = _resolveComponent("el-dialog");

      var _component_el_date_picker = _resolveComponent("el-date-picker");

      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(authWrap, {
        "search-params": _unref(searchParams)
      }, {
        titleCon: _withCtx(function () {
          return [_createElementVNode("div", null, [_unref(isAdmin) && _unref(isBeacon) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            icon: "setting",
            onClick: showDialogVisible
          }, {
            default: _withCtx(function () {
              return [_hoisted_1];
            }),
            _: 1
          })) : _createCommentVNode("", true), _unref(isAdmin) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            icon: "plus",
            onClick: addMaster
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          })) : _createCommentVNode("", true)])];
        }),
        default: _withCtx(function () {
          return [!_unref(isAdmin) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _withDirectives(_createElementVNode("span", null, "无", 512), [[_vShow, myRoleList.value.length === 0]])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myRoleList.value, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, _toDisplayString(item.name), 1);
          }), 128))]), _hoisted_7, !_unref(isAdmin) ? (_openBlock(), _createElementBlock("div", _hoisted_8, "该空间全部角色组：")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(authList.value, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass({
                active: currentAuth.value.id == item.id
              }),
              onClick: function onClick($event) {
                return changeCurrentAuth(item);
              }
            }, [_createElementVNode("span", null, _toDisplayString("".concat(item.name, "(").concat(item.member_list.length, ")")), 1), _createVNode(_component_el_icon, {
              onClick: _withModifiers(function ($event) {
                return delBtn(item, index);
              }, ["stop"]),
              class: "close"
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_close)];
              }),
              _: 2
            }, 1032, ["onClick"])], 10, _hoisted_10);
          }), 128))]), _hoisted_11, _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", {
            class: "userGroup part-box flex-n",
            style: _normalizeStyle("height: calc(100vh - ".concat(_unref(isAdmin) ? 350 : 405, "px)"))
          }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("label", _hoisted_14, "现有成员" + _toDisplayString(currentAuth.value ? currentAuth.value.member_list.length : 0), 1), _withDirectives(_createElementVNode("a", {
            class: "link1",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return dialogVisible.value = true;
            })
          }, "+添加成员", 512), [[_vShow, _unref(isAdmin)]])]), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentAuth.value.member_list, function (user, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "user"
            }, [user.member_type === 'ORG' ? (_openBlock(), _createElementBlock("img", _hoisted_16)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: getUserAvatar(user.avatar, user.login_name)
            }, null, 8, _hoisted_17)), _createElementVNode("span", {
              class: _normalizeClass(user.member_type)
            }, _toDisplayString(user.name), 3), _withDirectives(_createVNode(_component_el_icon, {
              class: "el-icon-close cursor",
              style: {
                "position": "absolute",
                "right": "0"
              },
              onClick: function onClick($event) {
                return delUser(user);
              }
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_close)];
              }),
              _: 2
            }, 1032, ["onClick"]), [[_vShow, _unref(isAdmin)]])]);
          }), 128))])], 4), _createElementVNode("div", _hoisted_18, [currentAuth.value.role_type !== ADMIN_GROUP_ID.value && _unref(isAdmin) ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_button, {
            type: editFlag.value ? 'primary' : 'text',
            onClick: editSubmit
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(editBtnText)), 1)];
            }),
            _: 1
          }, 8, ["type"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentAuth.value.module_list, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex0 mb10"
            }, [_createElementVNode("label", _hoisted_21, _toDisplayString(item.module_group_name), 1), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.module_list, function (actionItem, index) {
              return _openBlock(), _createBlock(_component_el_checkbox, {
                key: index,
                modelValue: actionItem.has_permission,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return actionItem.has_permission = $event;
                },
                class: "auth-item",
                label: actionItem.module_name,
                disabled: !editFlag.value
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "disabled"]);
            }), 128))])]);
          }), 128))])]), _createElementVNode("div", _hoisted_22, [currentAuth.value.role_type !== 'BIZ_ADMIN_ROLE' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [remarkFlag.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return saveRemark();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_24];
            }),
            _: 1
          })) : _createCommentVNode("", true), remarkFlag.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return remarkFlag.value = false;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_25];
            }),
            _: 1
          })) : _unref(isAdmin) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return editRemark();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_26];
            }),
            _: 1
          })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [!_unref(isAdmin) && _unref(applyRoleIndex) === -1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: applyRoleGroup
          }, {
            default: _withCtx(function () {
              return [_hoisted_28];
            }),
            _: 1
          })) : _createCommentVNode("", true)]), _hoisted_29, _createElementVNode("div", _hoisted_30, [_hoisted_31, _createTextVNode(_toDisplayString(currentAuth.value.id), 1)]), remarkFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_32, [_hoisted_33, _createVNode(_component_el_input, {
            modelValue: currentAuthCopy.value.roleName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return currentAuthCopy.value.roleName = $event;
            })
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createVNode(_component_el_input, {
            type: "textarea",
            rows: 5,
            modelValue: currentAuthCopy.value.remark,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return currentAuthCopy.value.remark = $event;
            })
          }, null, 8, ["modelValue"])])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createElementVNode("div", _hoisted_36, [_hoisted_37, _createTextVNode(_toDisplayString(currentAuth.value.name), 1)]), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createTextVNode(_toDisplayString(currentAuth.value.remark || '无'), 1)])], 64))])])), [[_directive_loading, loadingStatus.value]]), _createVNode(_component_el_dialog, {
            modelValue: _unref(permissionForm).dialogVisible,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return _unref(permissionForm).dialogVisible = $event;
            }),
            width: '840px',
            class: "permis-dialog",
            "lock-scroll": true
          }, {
            title: _withCtx(function () {
              return [_hoisted_40];
            }),
            footer: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_42, [_createVNode(_component_el_button, {
                onClick: handleCancel
              }, {
                default: _withCtx(function () {
                  return [_hoisted_43];
                }),
                _: 1
              }), _createVNode(_component_el_button, {
                type: "primary",
                onClick: handleSubmit
              }, {
                default: _withCtx(function () {
                  return [_hoisted_44];
                }),
                _: 1
              })])];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectLimitOptions.value, function (item, index) {
                return _openBlock(), _createBlock(selectLimit, {
                  key: index,
                  options: item,
                  options2: selectGroupData.value,
                  options3: selectMemberData.value,
                  options4: _unref(getPermInfoData)[item.value],
                  onLimitChange: handleSelectChange
                }, null, 8, ["options", "options2", "options3", "options4"]);
              }), 128))])];
            }),
            _: 1
          }, 8, ["modelValue"]), _createVNode(modalDialog, {
            options: _unref(optionsRole),
            onUpdateOption: updateDialogOption,
            onOnDialogSubmit: submitRole
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_45, [_hoisted_46, _createVNode(_component_el_input, {
                modelValue: inputRole.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                  return inputRole.value = $event;
                }),
                modelModifiers: {
                  trim: true
                },
                class: "w400",
                placeholder: "请输入内容"
              }, null, 8, ["modelValue"])])];
            }),
            _: 1
          }, 8, ["options"]), _createVNode(_component_el_dialog, {
            title: "添加成员",
            modelValue: dialogVisible.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
              return dialogVisible.value = $event;
            }),
            width: "590px"
          }, {
            footer: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_53, [_createVNode(_component_el_button, {
                onClick: closeAddUserDialog
              }, {
                default: _withCtx(function () {
                  return [_hoisted_54];
                }),
                _: 1
              }), _createVNode(_component_el_button, {
                type: "primary",
                onClick: addUser
              }, {
                default: _withCtx(function () {
                  return [_hoisted_55];
                }),
                _: 1
              })])];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_47, [_hoisted_48, _createElementVNode("label", null, _toDisplayString(currentAuth.value.name), 1)]), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createVNode(_component_el_date_picker, {
                modelValue: impowerInvalidTime.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
                  return impowerInvalidTime.value = $event;
                }),
                type: "date",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD",
                placeholder: "选择日期"
              }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_51, [_hoisted_52, _unref(addUserByGroupAuthorization) || _unref(enableRoleSearch) ? (_openBlock(), _createBlock(authMember, {
                key: 0,
                class: "filling",
                "panel-width": 525,
                "auth-option": _unref(authOption),
                onUpdateAuthOption: updateAuthOption
              }, null, 8, ["auth-option"])) : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                modelValue: membersEmail.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
                  return membersEmail.value = $event;
                }),
                placeholder: "请输入邮箱，多个成员用英文分号;隔开"
              }, null, 8, ["modelValue"]))])];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["search-params"]);
    };
  }
});